module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_s_detail.e8574329.png";